<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">View Document</h4>
</div>
<div class="modal-body">
    <div class="spinner" *ngIf="true == loading"></div>
    <div #docview [hidden]="true == loading"></div>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--primary" type="button" (click)="cancel()">Close</button>
    </div>
</div>